module.exports = __webpack_public_path__ + "static/ithor-multi-agent-451c7b5565dff03378665649e1f0979c.gif";